<script>
import { mapState } from "vuex";

export default {
  components: {  },
  data() {
    return {
      numSeconds: 300,
      interval: 0,
      displayValue: '00:00',
      now: Date.now(),
      percentage: 0
    }
  },
  computed: {
    ...mapState(["session", "timer", "modals", "fabled", "grimoire"])
  },
  mounted() {
    this.interval = setInterval(this.updateClock, 50);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    updateClock() {
      this.now = Date.now();
      const t = Math.max(0, (this.$store.state.timer.end - this.now) / 1000);
      this.displayValue = `${String(Math.floor(t / 60)).padStart(2, "0")}:${String(Math.floor(t % 60)).padStart(2, "0")}`;
      this.percentage = Math.min(Math.max(0, 100 - t / 60 * 100), 100);
    },
    setTimer(state, end) {
      this.$store.commit("setTimer", {timer: state, end});
    }
  },
  watch: {
    percentage(val) {
      if (val === 100 && this.timer.state === 'running' && !this.grimoire.isMuted) {
        const audio = new Audio(require("../../assets/sounds/bell.mp3"));
        audio.volume = 0.9;
        audio.play();
        if (!this.isSpectator) {
          setTimeout(() => this.setTimer('inactive', 0), 10000);
        }
      }
    }
  }
};
</script>

<template>
<div class="timer" v-if="!!session.sessionId && (!session.isSpectator || timer.state !== 'inactive' && timer.end > 0)">
  <div class="circle"></div>
  Round Timer: <strong :style="{'--percentage': percentage}">{{ displayValue }}</strong>
  <div class="controls" v-if="!session.isSpectator">
    <input v-model="numSeconds" type="number" size="4" style="width: 100px;" placeholder="Time (s)" />
    <div class="button-group button-group-small">
      <span class="button" v-on:click="setTimer('running', Date.now() + numSeconds * 1000)">Start</span>
      <span class="button" v-on:click="setTimer('inactive', 0)">Stop</span>
    </div>
  </div>
</div>
</template>

<style scoped lang="scss">
@import "../../vars";

.timer {
  font-family: 'PiratesBay', cursive;
  position: absolute;
  left: 10px;
  top: 100px;
  background: rgba(0, 0, 0, 0.5);
  border: 2px solid #000;
  border-radius: 7px;
  filter: drop-shadow(rgba(0, 0, 0, 0.5) 0px 4px 6px);
  padding: 5px;
  font-size: 130%;
}

.controls {

  display: flex;
  padding-top: 5px;

  input {

    margin-top: 5px;
    margin-bottom: 5px;

    padding-left: 5px;

    border: 2px solid #000;
    border-radius: 7px;

  }

  .button-group {

    margin-left: 5px;

  }

}

strong {
  color: color-mix(in hsl, #fff, $demon calc(1% * var(--percentage)));
}
</style>
